import { Instagram } from "lucide-react";
import { SectionHeading } from "../common/SectionHeading";
import { Reveal } from "../common/Reveal";
import { IMAGES } from "../../lib/data";

const SHOTS = [
    { image: IMAGES.familyServe, span: "col-span-2 row-span-2", alt: "Cotton candy served to a young guest" },
    { image: IMAGES.girlTreat, span: "", alt: "Kids with cotton candy at an outdoor event" },
    { image: IMAGES.popcorn, span: "", alt: "Fresh gourmet popcorn" },
    { image: IMAGES.birthday, span: "row-span-2", alt: "Colorful birthday candles" },
    { image: IMAGES.teens, span: "", alt: "Friends celebrating together" },
    { image: IMAGES.cottonCandy, span: "col-span-2", alt: "Cotton candy held up against the sky" },
];

export const Moments = () => (
    <section data-testid="moments-section" className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <SectionHeading
                    chapter="08"
                    kicker="The Proof"
                    title="#ShowtimeMoments"
                    copy="Real events. Real sugar highs. Tag us when the show hits your feed."
                    testid="moments-heading"
                />
                <Reveal delay={0.1} className="mb-14 md:mb-20">
                    <span className="inline-flex items-center gap-2 rounded-full border border-zinc-300 px-5 py-2.5 text-xs font-bold tracking-[0.2em] uppercase text-zinc-500">
                        <Instagram size={14} /> Live feed coming soon
                    </span>
                </Reveal>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] md:auto-rows-[200px] gap-2 md:gap-3" data-testid="moments-grid">
                {SHOTS.map((shot, i) => (
                    <Reveal key={i} delay={i * 0.05} className={shot.span}>
                        <div className="group relative h-full w-full overflow-hidden rounded-2xl">
                            <img
                                src={shot.image}
                                alt={shot.alt}
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-pink/0 transition-colors duration-500 group-hover:bg-pink/20" />
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
